const ordenDeServicioLiquidarStore = {
  namespaced: true,
  state: () => ({
    list: [],
    liquidado: null,
    monedas: [],
  }),
  mutations: {
    load(state, { list, liquidado, monedas }) {
      state.list = list;
      state.liquidado = liquidado;
      state.monedas = monedas;
    },
    new(state) {
      state.list.push({
        isNew: true,
        id: new Date().getTime(),
        fecha: "",
        otroServicio: "",
        otroHotel: "",
        otroTipo: "",
        tarifa: "",
        observaciones: "",
      });
    },
    updateList(state, list) {
      state.list = list;
    },
    setLiquidado(state, liquidado) {
      state.liquidado = liquidado;
    },
  },
  getters: {
    estaLiquidado(state) {
      return !!state.liquidado;
    },
    total(state) {
      // return state.list.reduce((old, val) => old + Number(val.tarifa) || 0, 0);
      const tienen_moneda = state.list.filter((item) => item.tempMoneda);

      const monedas = {};

      tienen_moneda.forEach((item) => {
        if (monedas[item.tempMoneda]) {
          monedas[item.tempMoneda] = monedas[item.tempMoneda] + Number(item.tarifa);
        } else {
          monedas[item.tempMoneda] = Number(item.tarifa);
        }
      });

      return monedas;
    },
    monedas: (state) => state.monedas,
  },
  actions: {
    remove({ commit, state }, id) {
      const newList = state.list.filter((item) => item.id != id);
      commit("updateList", newList);
    },
    save({ commit, state }, liquidado) {
      const list = state.list.map((item) => {
        return {
          ...item,
          isNew: false,
          moneda: item.tempMoneda,
        };
      });

      commit("load", {
        list: list,
        liquidado: liquidado,
      });
    },
  },
};

export default ordenDeServicioLiquidarStore;
